import Image from 'next/image';
import type { ComponentProps } from 'react';

interface Props extends Omit<ComponentProps<typeof Image>, 'alt'> {
    className?: string;
    'data-testid'?: string;
    alt?: string;
}

const ImageWrapper = ({ alt, ...props }: Props) => {
    return (
        <span className={props.className} style={{ height: props.height, width: props.width }}>
            <Image {...props} alt={alt || ''} />
        </span>
    );
};

export default ImageWrapper;
